import { render, staticRenderFns } from "./technicianExamineNotice.vue?vue&type=template&id=0d4c861a&scoped=true"
import script from "./technicianExamineNotice.vue?vue&type=script&lang=js"
export * from "./technicianExamineNotice.vue?vue&type=script&lang=js"
import style0 from "./technicianExamineNotice.vue?vue&type=style&index=0&id=0d4c861a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4c861a",
  null
  
)

export default component.exports